<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="modal-box-bg"
      @click="$emit('closeModal')"
    >
      <div class="modal-box" @click.stop="() => {}">
        <div class="modal-content">
          <slot></slot>
        </div>
      </div>

      <div class="modal-close">
        <button class="btn modal-close__btn" @click="$emit('closeModal')">
          <i class="ti-close"></i>
        </button>
      </div>
      
    </div>
  </transition>
</template>
<script>

export default {
  name: 'modal-popup',

  props: {
    isVisible: false
  },
}
</script>
<style lang="scss" scoped>

.modal-box-bg {
  background: rgba(#000, .8);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(#000, .7);
  color: #fff;
  opacity: 1;
  pointer-events: auto;
  transition: 200ms all ease-in-out;
  width: 100%;
  // max-width: 1024px;
  z-index: 100;

  .modal-content {
    color: #000;
    height: 100%;
    max-height: calc(100vh - 200px);
    overflow: auto;
    width: 100%;
    padding: 0;
  }
}

.modal-close {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;

  &__btn {
    background: transparent;
    border: none;
    font-size: 20px;
    height: 40px;
    width: 40px;

    i {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.fade-enter-active {
  opacity: 1;
}
.fade-leave-active {
  transition: all 200ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
